import React, { useState, useEffect } from "react";

import DropWindow from "./../components/DropWindow";
import dagens from "../lib/menyer";
import { useLanguage } from "../i18n";

const Meny = () => {
  const { lang, t } = useLanguage();
  const Mat = dagens[`mat_${lang}`] || dagens["mat"];

  return (
    <>
      <h2>{t('menu.title')}</h2>
      <Mat />
    </>
  );
};

function Menu() {
  const [dropdown, setDropdown] = useState("");

  function getMenu() {
    setDropdown("menu");
  }

  useEffect(() => {
    getMenu();
  }, []);

  return (
    <DropWindow dropdown={dropdown} setDropdown={setDropdown}>
      <Meny />
    </DropWindow>
  );
}

export default Menu;
